exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slide-enter-active,.slide-leave-active{-webkit-transition:1s;transition:1s}.slide-enter{-webkit-transform:translate(100%);transform:translate(100%)}.slide-leave-to{-webkit-transform:translate(-100%);transform:translate(-100%)}", ""]);

// exports
